import { memo } from 'react';
import { useTheme, BASE_ANIMATION_DURATION } from '@shopify/polaris-viz-core';
import { useSpring, animated } from '@react-spring/web';
import styles from './Point.scss.js';
import { jsx } from 'react/jsx-runtime';
import { classNames } from '../../utilities/classnames.js';

const DEFAULT_RADIUS = 5;
const Point = /*#__PURE__*/memo(function Point({
  dataType,
  cx,
  cy,
  active,
  color,
  onFocus,
  index,
  ariaLabelledby,
  tabIndex = -1,
  isAnimated,
  ariaHidden = false,
  visuallyHidden = false
}) {
  const selectedTheme = useTheme();

  const handleFocus = () => {
    if (onFocus != null) {
      return onFocus({
        index,
        x: typeof cx === 'number' ? cx : cx.get(),
        y: typeof cy === 'number' ? cy : cy.get()
      });
    }
  };

  const radius = active ? DEFAULT_RADIUS : 0;
  const {
    animatedRadius
  } = useSpring({
    animatedRadius: radius,
    from: {
      animatedRadius: 0
    },
    config: {
      duration: BASE_ANIMATION_DURATION
    },
    default: {
      immediate: !isAnimated
    }
  });
  return /*#__PURE__*/jsx(animated.circle, {
    "data-type": dataType,
    "data-index": index,
    role: ariaLabelledby == null ? '' : 'image',
    "aria-labelledby": ariaLabelledby,
    tabIndex: tabIndex,
    cx: cx,
    cy: cy,
    r: isAnimated ? animatedRadius : radius,
    fill: color,
    stroke: selectedTheme.line.pointStroke,
    strokeWidth: 2,
    onFocus: handleFocus,
    className: classNames(styles.Point, visuallyHidden ? styles.VisuallyHidden : null),
    "aria-hidden": ariaHidden
  });
});

export { Point };
